<div class="copy-configuration-list" *ngIf="!isConfigurationListEmpty; else loading">
  <div class="search-control">
    <mat-form-field class="configuration-search" appearance="fill">
      <mat-label>{{ "system.search" | translate }}</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input [formControl]="searchControl" matInput/>
      <button *ngIf="isSearchValue" (click)="clearSearch()" mat-icon-button matSuffix matTooltip="Clear"
              class="clear-button">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <div class="table-wrapper">
    <mat-table [dataSource]="dataSource">
      <ng-container [matColumnDef]="copyConfigurationColumns.Description">
        <mat-cell *matCellDef="let configuration"> {{ getSourceDescription(configuration.Description) }}</mat-cell>
      </ng-container>

      <ng-container [matColumnDef]="copyConfigurationColumns.Slug">
        <mat-cell *matCellDef="let configuration"> {{ configuration.Slug }}</mat-cell>
      </ng-container>

      <ng-container [matColumnDef]="copyConfigurationColumns.Type">
        <mat-cell *matCellDef="let configuration"> {{ getSourceTypeTitle(configuration.Type) }}</mat-cell>
      </ng-container>

      <ng-container [matColumnDef]="copyConfigurationColumns.Favorite">
        <mat-cell *matCellDef="let configuration">
          <mat-icon *ngIf="configuration.RootFeatureLayerConfiguration.IsFavorite">bookmark</mat-icon>
        </mat-cell>
      </ng-container>

      <mat-row
        *matRowDef="let configuration; columns: displayedColumns"
        (click)="selectConfiguration(configuration)">
      </mat-row>
    </mat-table>
  </div>
</div>

<ng-template #loading>
  <div class="spinner-wrapper">
    <div class="loading-wrapper">
      <mat-spinner class="load-spinner" diameter="80" strokeWidth="6"></mat-spinner>
    </div>
  </div>
</ng-template>
